type hiwItemProps = {
  image: JSX.Element;
  description?: JSX.Element;
};

type Props = React.ComponentPropsWithoutRef<'div'> & hiwItemProps;

const HIWItem = ({ image, description }: Props) => {
  return (
    <div className="mb-32 flex flex-col items-center xs:mb-0">
      {image}
      <div className="mt-16 flex">{description && description}</div>
    </div>
  );
};

export default HIWItem;
